import { createContext, useContext } from 'react';
import type { Experience } from '../../data/experiences';
import type { BookingSource } from '../../lib/analytics';

export interface BookingContextValue {
  /**
   * Open the in-site booking flow. With no experience, the wizard starts on the
   * experience-chooser step; with one, it starts pre-filled on the package step.
   * `source` records the entry point for analytics/attribution.
   */
  openBooking: (
    experience?: Experience,
    optionId?: number,
    source?: BookingSource,
    /** Preselect a package by its LinkTwist option alias (resolved to its id). */
    optionAlias?: string,
  ) => void;
}

export const BookingContext = createContext<BookingContextValue | null>(null);

export function useBooking(): BookingContextValue {
  const ctx = useContext(BookingContext);
  if (!ctx) {
    throw new Error('useBooking must be used within a <BookingProvider>');
  }
  return ctx;
}
